import * as React from "react";
import {useEffect, useState} from "react";
import {RouteComponentProps} from "react-router-dom";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {IScreens} from "IncompleteInfoV2/interface";
import {pageTitle, ScreenNames} from "IncompleteInfoV2/utils";
import {updateSubStatuses} from "IncompleteInfoV2/api";
import {removeCompletedSubStatus, showToast} from "IncompleteInfoV2/actions";
import {history} from "load/store";
import Loading from "components/loading";
import KycIndex from "Kyc";
import {clearKycStates, setKycInvoker, setProductCode} from "Kyc/action";
import {KycInvoker} from "Kyc/utils";
import ContainerBox from "myshubhlife-component/container-box";
import {IState as IKycState} from "Kyc/reducer";
import {indexPath} from "IncompleteInfoV2/routes";
import {COLOR} from "utils/variables";
import {ILatestStatus} from "profile/interface";

interface IConnectProps {
    dispatch?: (action: any) => void;
    userId: number;
    screens: IScreens;
    applicationId: number;
    applicationInfo: ILatestStatus;
    kyc: IKycState;
}

const Kyc = (props: IConnectProps & RouteComponentProps) => {
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        props.dispatch(setKycInvoker(KycInvoker.INCOMPLETE_INFO));
        props.dispatch(setProductCode(props.applicationInfo.productType));
    }, []);
    useEffect(() => {
        if (props.kyc.completed && props.kyc.invoker === KycInvoker.INCOMPLETE_INFO) {
            (async () => {
                try {
                    setLoading(true);
                    const removeStatus = await updateSubStatuses(props.applicationId,
                        props.screens[ScreenNames.KYC].subStatuses);
                    if (removeStatus.status === 200) {
                        props.dispatch(showToast(COLOR.GREEN, "KYC updated successfully"));
                        props.dispatch(removeCompletedSubStatus(ScreenNames.KYC));
                        setLoading(false);
                        history.replace({pathname: indexPath});
                    }
                } catch (err) {
                    setLoading(false);
                }
            })();
            props.dispatch(clearKycStates());
        }
    }, [props.kyc.completed]);
    return (
        <ContainerBox>
            <Loading active={loading} msg="Please wait while saving.." />
            <KycIndex {...props} />
        </ContainerBox>
    );
};

const mapStateToProps = (state: IReduxState): IConnectProps =>  {
    return {
        userId: state.login.auth.userId,
        screens: state.incompleteInfoV2.screens,
        applicationId: state?.profileInfo?.latestStatus?.applicationId,
        applicationInfo: state?.profileInfo?.latestStatus,
        kyc: state.kyc,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(Kyc);
